import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'

const Icon = ({ className, isReplyingDirect, isReplyingAll, isForwarding }) => {
  return (
    <div
      className={cn(className, 'Icon', {
        'Icon-reply': isReplyingDirect,
        'Icon-forward': isForwarding,
        'Icon-reply-all': isReplyingAll,
      })}
    />
  )
}

export default styled(Icon)`
  font-size: 16px !important;
`
